import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button } from '@mui/material';
import { Phone, Email, LocationOn } from '@mui/icons-material';

const Contact = () => {
  return (
    <Box sx={{ minHeight: '100vh', pt: 12, pb: 10 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          sx={{ mb: 6, fontWeight: 'bold', color: 'white' }}
        >
          Kontakt
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={4}>
            <Card sx={{ bgcolor: '#1a3a44', color: 'white', height: '100%', maxWidth: { xs: '100%', md: '350px' }, mx: 'auto' }}>
              <CardContent sx={{ textAlign: 'center', py: 4 }}>
                <Phone sx={{ fontSize: 50, color: '#ffd700', mb: 2 }} />
                <Typography variant="h5" sx={{ mb: 2 }}>
                  Telefon
                </Typography>
                <Typography variant="h6" sx={{ color: '#55d6dc' }}>
                  +4915563819185
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, opacity: 0.8 }}>
                  Mo-Sa: 8:00 - 20:00 Uhr
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ bgcolor: '#1a3a44', color: 'white', height: '100%' }}>
              <CardContent sx={{ textAlign: 'center', py: 4 }}>
                <Email sx={{ fontSize: 50, color: '#ffd700', mb: 2 }} />
                <Typography variant="h5" sx={{ mb: 2 }}>
                  E-Mail
                </Typography>
                <Typography variant="h6" sx={{ color: '#55d6dc' }}>
                  info@hnumzugsservice.de
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, opacity: 0.8 }}>
                  24/7 Antwort innerhalb 24h
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ bgcolor: '#1a3a44', color: 'white', height: '100%', maxWidth: { xs: '100%', md: '350px' }, mx: 'auto' }}>
              <CardContent sx={{ textAlign: 'center', py: 4 }}>
                <LocationOn sx={{ fontSize: 50, color: '#ffd700', mb: 2 }} />
                <Typography variant="h5" sx={{ mb: 2 }}>
                  Adresse
                </Typography>
                <Typography variant="h6" sx={{ color: '#55d6dc' }}>
                  Vahrenwalder Str. 269 a
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, opacity: 0.8 }}>
                  30179 Hannover
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ mb: 3, color: '#55d6dc' }}>
            Kostenloses Angebot anfordern
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, color: 'white', opacity: 0.9 }}>
            Kontaktieren Sie uns für ein unverbindliches Angebot
          </Typography>
          <Button
            variant="contained"
            size="large"
            href="tel:+4915563819185"
            sx={{
              bgcolor: '#55d6dc',
              color: '#275664',
              px: 4,
              py: 2,
              fontSize: '1.2rem',
              fontWeight: 'bold',
              '&:hover': {
                bgcolor: '#4bc2c8'
              }
            }}
          >
            Jetzt anrufen
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Contact;